/**
 * API pour les services externes (SMS, Navixy, etc.)
 * Utilise les credentials depuis la configuration
 */
import axios from 'axios';
import config from '../config/api';
import { formatErrorForToast } from '../utils/errorHandler';

/**
 * Envoie un SMS via l'API Morocco SMS
 */
export const sendSMS = async (phone, message) => {
  try {
    const { sms } = config;
    
    // Vérifier que les credentials sont configurés
    if (!sms.subAccount || !sms.subAccountPass) {
      throw new Error('Configuration SMS manquante. Vérifiez les variables d\'environnement.');
    }

    const url = `${sms.apiUrl}?sub_account=${sms.subAccount}&sub_account_pass=${sms.subAccountPass}&action=send_sms&sender_id=${sms.senderId}&message=${encodeURIComponent(message)}&recipients=${phone}`;
    
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur envoi SMS:', error);
    throw error;
  }
};

/**
 * Récupère la position d'un véhicule via Navixy
 */
export const fetchVehicleLocation = async (trackerId) => {
  try {
    const { navixy } = config;
    
    // Vérifier que le hash est configuré
    if (!navixy.hash) {
      throw new Error('Configuration Navixy manquante. Vérifiez les variables d\'environnement.');
    }

    const data = {
      hash: navixy.hash,
      tracker_id: trackerId,
    };
    
    const response = await axios.post(
      `${navixy.apiUrl}/tracker/get_state`,
      data,
      {
        headers: { 'Content-Type': 'application/json' },
        // Ne pas envoyer de cookies/credentials vers Navixy pour éviter les erreurs CORS
        withCredentials: false,
      }
    );
    
    return {
      lat: response.data.state.gps.location.lat,
      lng: response.data.state.gps.location.lng,
    };
  } catch (error) {
    console.error('Error fetching vehicle location:', error);
    return null;
  }
};

